/* ═══════════════════════════════════════════════════════════════════
   MATRIKAR — Vehicle Fit Selector JS (externalized P6 — 2026-05-22)
   Source : snippets/matrikar-vehicle-fit.liquid (formerly inline)
   Loaded : defer, only on PDPs (via Liquid conditional in snippet)
   Reads bootstrap inline global :
     window.MK_VFIT_SHOW_STEERING — boolean from {% assign show_steering %}
   Reads pre-existing async globals :
     window.MATRIKAR_DB, window.MATRIKAR_FUEL, window.MATRIKAR_GEN_YEAR,
     window.MATRIKAR_EXPAND_YEARS (all loaded via matrikar-data.js +
     matrikar-shared.js, both defer in layout/theme.liquid)
   ═══════════════════════════════════════════════════════════════════ */

(function () {
  var DB = null;
  var sel = { make: '', model: '', year: '', sub: '', seats: '', drive: '', fuel: '' };
  var FUEL = window.MATRIKAR_FUEL || { P: 'Petrol/Diesel', E: 'Electric', PH: 'Plug-in Hybrid', FH: 'Full Hybrid', MH: 'Mild Hybrid', FC: 'Fuel Cell' };
  var isLoading = true;
  var btnObserver = null;

  function g(id) { return document.getElementById(id); }
  function uniq(arr) { return [...new Set(arr)].sort(); }
  function esc(s) { return (s || '').replace(/'/g, "\\'"); }

  function getProductForm() {
    var form = document.querySelector('form[action="/cart/add"][id^="product-form-main"]:not([id*="payment-installment"])');
    if (!form) form = document.querySelector('form[action="/cart/add"]:not([id*="payment-installment"])');
    if (!form) form = document.querySelector('[id^="product-form-"]:not([id*="payment-installment"])');
    if (!form) form = document.querySelector('.product-form');
    if (!form) {
      var buyButtons = document.querySelector('buy-buttons');
      if (buyButtons) form = buyButtons.closest('form');
    }
    return form;
  }

  function isVehicleConfirmed() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('matrikar_vehicle') || 'null'); } catch(e) {}
    return !!(saved && saved.make && saved.year && saved.model);
  }

  // ─── Core button lock (no loop) ──────────────────────────────────────────
  function forceButtonState() {
    var confirmed = isVehicleConfirmed();
    var form = getProductForm();
    if (!form) return;

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      if (!confirmed) {
        if (submitBtn.disabled !== true) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-disabled', 'true');
          submitBtn.style.opacity = '0.5';
          submitBtn.style.cursor = 'not-allowed';
          submitBtn.title = 'Please confirm your vehicle first';
        }
      } else {
        if (submitBtn.disabled === true) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.style.opacity = '';
          submitBtn.style.cursor = '';
          submitBtn.title = '';
        }
      }
    }

    var payBtn = form.querySelector('.shopify-payment-button button');
    if (payBtn) {
      if (!confirmed) {
        if (payBtn.disabled !== true) {
          payBtn.disabled = true;
          payBtn.style.opacity = '0.5';
          payBtn.style.cursor = 'not-allowed';
        }
      } else {
        if (payBtn.disabled === true) {
          payBtn.disabled = false;
          payBtn.style.opacity = '';
          payBtn.style.cursor = '';
        }
      }
    }

    var msg = document.getElementById('mkvfit-required-message');
    if (!confirmed) {
      if (!msg) {
        msg = document.createElement('div');
        msg.id = 'mkvfit-required-message';
        msg.className = 'mkvfit-required-message';
        msg.textContent = '⚠️ Please confirm your vehicle selection before adding to cart';
        if (submitBtn && submitBtn.parentNode) {
          submitBtn.parentNode.insertBefore(msg, submitBtn.nextSibling);
        }
      }
    } else {
      if (msg) msg.remove();
    }
  }

  var reapplyTimer = null;
  function reapplyButtonState() {
    clearTimeout(reapplyTimer);
    reapplyTimer = setTimeout(forceButtonState, 60);
  }

  // ─── MutationObserver (now safe) ─────────────────────────────────────────
  function attachButtonObserver() {
    if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }
    var form = getProductForm();
    if (!form) return;
    var submitBtn = form.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    btnObserver = new MutationObserver(function(mutations) {
      if (isVehicleConfirmed()) return;
      if (submitBtn.disabled === true) return;
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.style.opacity = '0.5';
      submitBtn.style.cursor = 'not-allowed';
    });

    btnObserver.observe(submitBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'style'] });
  }

  function onVehicleChange() {
    forceButtonState();
  }

  // ─── Cart properties ─────────────────────────────────────────────────────
  function ensureCartProperties() {
    var form = getProductForm();
    if (!form) return;
    form.querySelectorAll('[data-mkvfit]').forEach(function(p) { p.remove(); });
    [
      { key: 'vehicle', name: 'Vehicle' },
      { key: 'year',    name: 'Vehicle Year' },
      { key: 'trim',    name: 'Trim' },
      { key: 'seats',   name: 'Seats' },
      { key: 'drive',   name: 'Drive Side' },
      { key: 'fuel',    name: 'Fuel Type' }
    ].forEach(function(prop) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + prop.name + ']';
      input.setAttribute('data-mkvfit', prop.key);
      form.appendChild(input);
    });
  }

  function updateCartProperties(data) {
    var form = getProductForm();
    if (!form) return;
    var vehicleStr = (data.make || '') + ' ' + (data.model || '') + (data.sub ? ' ' + data.sub : '');
    var map = { vehicle: vehicleStr, year: data.year || '', trim: data.sub || '', seats: data.seats ? data.seats + ' seats' : '', drive: data.drive || '', fuel: data.fuel || '' };
    Object.keys(map).forEach(function(key) {
      var el = form.querySelector('[data-mkvfit="' + key + '"]');
      if (el) el.value = map[key];
    });
  }

  function clearCartProperties() {
    var form = getProductForm();
    if (!form) return;
    ['vehicle','year','trim','seats','drive','fuel'].forEach(function(key) {
      var el = form.querySelector('[data-mkvfit="' + key + '"]');
      if (el) el.value = '';
    });
  }

  function formatVehicleDetails(data) {
    var parts = [];
    if (data.seats) parts.push(data.seats + ' seats');
    if (data.drive) parts.push(data.drive);
    if (data.fuel)  parts.push(data.fuel);
    return parts.join(' · ');
  }

  // ─── Saved vehicle ───────────────────────────────────────────────────────
  function loadSavedVehicle() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem('matrikar_vehicle') || 'null'); } catch(e) {}

    // HOTFIX_HIDE_STEERING : normaliser RHD → LHD pour visiteurs résiduels
    if (saved && saved.drive === 'RHD') {
      saved.drive = 'LHD';
      try { localStorage.setItem('matrikar_vehicle', JSON.stringify(saved)); } catch (e) {}
    }

    if (saved && saved.make && saved.year && saved.model) {
      sel = saved;
      /* recompute _genYears so downstream pSub/pickDrive (after "Edit") can map sel.year to gen */
      if (DB) {
        sel._genYears = uniq(DB.filter(function(r) { return r.make === sel.make && r.model === sel.model; }).map(function(r) { return r.year; }));
      }
      updateCartProperties(sel);
      var displayName = saved.make + ' ' + saved.model + (saved.sub ? ' ' + saved.sub : '') + ' (' + saved.year + ')';
      var vehicleEl = g('mkvfit-vehicle-name');
      var detailsEl = g('mkvfit-vehicle-details');
      if (vehicleEl) vehicleEl.textContent = displayName;
      if (detailsEl) detailsEl.textContent = formatVehicleDetails(saved);
      g('mkvfit-saved').style.display = 'flex';
      g('mkvfit-selector').style.display = 'none';
      onVehicleChange();
      return true;
    } else {
      g('mkvfit-saved').style.display = 'none';
      g('mkvfit-selector').style.display = 'block';
      onVehicleChange();
      return false;
    }
  }

  function resetToEmpty() {
    localStorage.removeItem('matrikar_vehicle');
    sel = { make: '', model: '', year: '', sub: '', seats: '', drive: '', fuel: '' };
    clearCartProperties();
    g('mkvfit-saved').style.display = 'none';
    g('mkvfit-selector').style.display = 'block';
    resetSelectorUI();
    onVehicleChange();
    if (DB) initMakes(); else waitForDB(initMakes);
  }

  function resetSelectorUI() {
    g('mkvfit-lbl-make').textContent = 'Car Make';
    g('mkvfit-lbl-model').textContent = 'Model';
    g('mkvfit-lbl-year').textContent = 'Year';
    g('mkvfit-btn-make').classList.remove('filled');
    g('mkvfit-btn-model').classList.remove('filled');
    g('mkvfit-btn-year').classList.remove('filled');
    g('mkvfit-btn-model').classList.add('mkvfit-dropbtn--disabled');
    g('mkvfit-btn-year').classList.add('mkvfit-dropbtn--disabled');

    // Reset dots: make button already has red dot, model/year need grey
    var modelBtn = g('mkvfit-btn-model');
    var yearBtn = g('mkvfit-btn-year');
    if (modelBtn) {
      var modelDot = modelBtn.querySelector('.mkvfit-dot');
      if (modelDot) {
        modelDot.classList.remove('mkvfit-dot');
        modelDot.classList.add('mkvfit-dot--grey');
      }
    }
    if (yearBtn) {
      var yearDot = yearBtn.querySelector('.mkvfit-dot');
      if (yearDot) {
        yearDot.classList.remove('mkvfit-dot');
        yearDot.classList.add('mkvfit-dot--grey');
      }
    }

    ['trim','seats','drive','engine'].forEach(function(s) {
      var el = g('mkvfit-step-' + s);
      if (el) el.style.display = 'none';
    });
    var cw = g('mkvfit-confirm-wrap');
    if (cw) cw.style.display = 'none';
    document.querySelectorAll('.mkvfit-pill.active').forEach(function(p) { p.classList.remove('active'); });
  }

  // ─── DB ───────────────────────────────────────────────────────────────────
  // 7s timeout (70 × 100ms). Globals (FUEL/LOGOS) upgraded inside buildDB once matrikar-shared.js has run.
  function waitForDB(cb) {
    var attempts = 0;
    var check = function() {
      attempts++;
      if (typeof window.MATRIKAR_DB !== 'undefined' && window.MATRIKAR_DB !== null) {
        buildDB(); if (cb) cb(); isLoading = false; return;
      }
      if (attempts >= 70) {
        isLoading = false;
        var el = g('mkvfit-list-make');
        if (el) el.innerHTML = '<div class="mkvfit-dropitem" style="color:var(--mk-grey, #5E5E70);">Vehicle data unavailable. Please refresh the page or browse without selecting a vehicle.</div>';
        return;
      }
      setTimeout(check, 100);
    };
    check();
  }

  function buildDB() {
    if (DB) return;
    if (window.MATRIKAR_FUEL) FUEL = window.MATRIKAR_FUEL;
    var raw = window.MATRIKAR_DB;
    if (!raw || !raw.data) return;
    DB = raw.data.map(function(r) {
      return {
        make:  raw.makes ? raw.makes[r[0]] : r[0],
        model: r[1], sub: r[2], year: String(r[3]),
        seats: r[4],
        fuel:  FUEL[r[5]] || r[5] || 'Petrol/Diesel'
      };
    });
  }

  // ─── Dropdowns ────────────────────────────────────────────────────────────
  function closeDrops() {
    ['make','model','year'].forEach(function(k) {
      var el = g('mkvfit-drop-' + k);
      if (el) el.classList.remove('open');
    });
  }

  function togDrop(key) {
    var el = g('mkvfit-drop-' + key);
    var btn = g('mkvfit-btn-' + key);
    if (!el || btn.classList.contains('mkvfit-dropbtn--disabled')) return;
    var wasOpen = el.classList.contains('open');
    closeDrops();
    if (!wasOpen) {
      el.classList.add('open');
      var src = g('mkvfit-search-' + key);
      // HOTFIX_DROPDOWN_UX : pas de focus auto → clavier mobile reste fermé jusqu'au tap manuel
      if (src) { src.value = ''; filterList(key); }
    }
  }

  function filterList(key) {
    var src = g('mkvfit-search-' + key);
    if (!src) return;
    var q = src.value.toLowerCase();
    var list = g('mkvfit-list-' + key);
    if (!list) return;
    list.querySelectorAll('.mkvfit-dropitem').forEach(function(el) {
      el.style.display = el.dataset.v.toLowerCase().indexOf(q) > -1 ? '' : 'none';
    });
  }

  function buildList(listId, items, fn, activeVal) {
    var el = g(listId);
    if (!el) return;
    if (!items || !items.length) {
      el.innerHTML = '<div class="mkvfit-dropitem" style="color:var(--mk-grey, #5E5E70);">No options available</div>'; return;
    }
    el.innerHTML = items.map(function(v) {
      return '<div class="mkvfit-dropitem' + (v === activeVal ? ' active' : '') + '" data-v="' + v + '" onclick="MKVFIT.' + fn + '(\'' + esc(v) + '\')">' + v + '</div>';
    }).join('');
  }

  function initMakes() {
    if (!DB) return;
    buildList('mkvfit-list-make', uniq(DB.map(function(r) { return r.make; })), 'pMake', sel.make);
    g('mkvfit-btn-make').classList.remove('mkvfit-dropbtn--disabled');
  }

  function enableDrop(key) {
    var btn = g('mkvfit-btn-' + key);
    if (btn) {
      btn.classList.remove('mkvfit-dropbtn--disabled');
      // Change dot from grey to red
      var dot = btn.querySelector('.mkvfit-dot');
      if (dot && dot.classList.contains('mkvfit-dot--grey')) {
        dot.classList.remove('mkvfit-dot--grey');
        dot.classList.add('mkvfit-dot');
      }
    }
  }

  function clearStepsFrom(from) {
    var order = ['trim','seats','drive','engine'];
    for (var i = order.indexOf(from); i < order.length; i++) {
      var el = g('mkvfit-step-' + order[i]);
      if (el) el.style.display = 'none';
    }
    g('mkvfit-confirm-wrap').style.display = 'none';
  }

  // P8 AUTO-CONFIRM : press animation (300ms total) + trigger MKVFIT.confirm()
  // Triggered from pFuel when all fields are auto-resolved (or mix auto + user choice).
  // Animation press : scale(0.95) hold 150ms then scale(1.0) 150ms ease.
  // Then call MKVFIT.confirm() which displays "Perfect Fit Confirmed" + CustomEvent.
  function tryAutoConfirm() {
    if (!sel.make || !sel.model || !sel.year || !sel.sub || !sel.seats || !sel.drive || !sel.fuel) return;
    setTimeout(function() {
      var confirmBtn = g('mkvfit-confirm-btn');
      if (!confirmBtn) {
        // Fallback if button not yet rendered : just confirm directly
        window.MKVFIT.confirm();
        return;
      }
      confirmBtn.style.transition = 'transform 0.225s cubic-bezier(0.4, 0.0, 0.2, 1), box-shadow 0.225s cubic-bezier(0.4, 0.0, 0.2, 1)';
      confirmBtn.style.transform = 'scale(0.95)';
      confirmBtn.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,0.12)';
      setTimeout(function() {
        confirmBtn.style.transform = 'scale(1.0)';
        confirmBtn.style.boxShadow = '';
        setTimeout(function() {
          confirmBtn.style.transition = '';
          window.MKVFIT.confirm();
        }, 225);
      }, 225);
    }, 150);
  }

  // ─── Public API ───────────────────────────────────────────────────────────
  window.MKVFIT = {
    pMake: function(m) {
      sel = { make: m, model: '', year: '', sub: '', seats: '', drive: '', fuel: '' };
      closeDrops();
      g('mkvfit-lbl-make').textContent = m; g('mkvfit-btn-make').classList.add('filled');
      g('mkvfit-lbl-model').textContent = 'Model'; g('mkvfit-btn-model').classList.remove('filled');
      g('mkvfit-lbl-year').textContent = 'Year'; g('mkvfit-btn-year').classList.remove('filled');
      clearStepsFrom('trim'); onVehicleChange();
      if (!DB) return;
      buildList('mkvfit-list-model', uniq(DB.filter(function(r) { return r.make === m; }).map(function(r) { return r.model; })), 'pModel', '');
      enableDrop('model'); setTimeout(function() { togDrop('model'); }, 60);
    },

    pModel: function(m) {
      sel.model = m; closeDrops();
      g('mkvfit-lbl-model').textContent = m; g('mkvfit-btn-model').classList.add('filled');
      clearStepsFrom('trim'); onVehicleChange();
      if (!DB) return;
      var genYrs = uniq(DB.filter(function(r) { return r.make === sel.make && r.model === m; }).map(function(r) { return r.year; }));
      sel._genYears = genYrs;
      var yrs = window.MATRIKAR_EXPAND_YEARS ? window.MATRIKAR_EXPAND_YEARS(genYrs) : genYrs.slice().reverse();
      buildList('mkvfit-list-year', yrs, 'pYear', '');
      enableDrop('year'); setTimeout(function() { togDrop('year'); }, 60);
    },

    pYear: function(y) {
      sel.year = y; closeDrops();
      g('mkvfit-lbl-year').textContent = y; g('mkvfit-btn-year').classList.add('filled');
      clearStepsFrom('trim'); onVehicleChange();
      if (!DB) return;
      var genY = window.MATRIKAR_GEN_YEAR ? window.MATRIKAR_GEN_YEAR(sel._genYears || [y], y) : y;
      var subs = uniq(DB.filter(function(r) { return r.make === sel.make && r.model === sel.model && r.year === genY; }).map(function(r) { return r.sub; }));
      // P8 AUTO-SELECT : if 1 sub, skip step display + auto-call pSub
      if (subs.length === 1) {
        setTimeout(function() { window.MKVFIT.pSub(subs[0]); }, 250);
        return;
      }
      // Fallback DB hole : if 0 subs, default to '-' to unlock downstream
      if (subs.length === 0) {
        setTimeout(function() { window.MKVFIT.pSub('-'); }, 250);
        return;
      }
      g('mkvfit-pills-trim').innerHTML = subs.map(function(s) {
        return '<div class="mkvfit-pill" onclick="MKVFIT.pSub(\'' + esc(s) + '\')">' + s + '</div>';
      }).join('');
      g('mkvfit-step-trim').style.display = 'flex';
    },

    pSub: function(s) {
      sel.sub = s;
      g('mkvfit-pills-trim').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === s); });
      clearStepsFrom('seats'); onVehicleChange();
      if (!DB) return;
      var genY = window.MATRIKAR_GEN_YEAR ? window.MATRIKAR_GEN_YEAR(sel._genYears || [sel.year], sel.year) : sel.year;
      var seats = uniq(DB.filter(function(r) {
        return r.make === sel.make && r.model === sel.model && r.year === genY && r.sub === s;
      }).map(function(r) { return String(r.seats); })).sort(function(a,b) { return +a - +b; });
      // P8 AUTO-SELECT : if 1 seats, skip step display + auto-call pSeats
      if (seats.length === 1) {
        setTimeout(function() { window.MKVFIT.pSeats(seats[0]); }, 250);
        return;
      }
      // Fallback DB hole : if 0 seats, default to '5' (most common)
      if (seats.length === 0) {
        setTimeout(function() { window.MKVFIT.pSeats('5'); }, 250);
        return;
      }
      g('mkvfit-pills-seats').innerHTML = seats.map(function(n) {
        return '<div class="mkvfit-pill" onclick="MKVFIT.pSeats(\'' + n + '\')">' + n + ' seats</div>';
      }).join('');
      g('mkvfit-step-seats').style.display = 'flex';
    },

    pSeats: function(s) {
      sel.seats = s;
      g('mkvfit-pills-seats').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === s + ' seats'); });
      clearStepsFrom('drive'); onVehicleChange();
      // P6 EXTRACT : read steering mode from window global (bootstrap inline)
      if (window.MK_VFIT_SHOW_STEERING) {
        var lhd = g('mkvfit-lhd'), rhd = g('mkvfit-rhd');
        if (lhd) { lhd.onclick = function() { MKVFIT.pickDrive('LHD'); }; lhd.classList.remove('active'); }
        if (rhd) { rhd.onclick = function() { MKVFIT.pickDrive('RHD'); }; rhd.classList.remove('active'); }
        g('mkvfit-step-drive').style.display = 'flex';
      } else {
        // HOTFIX_HIDE_STEERING : auto-set LHD (Canada+USA only)
        MKVFIT.pickDrive('LHD');
      }
    },

    pickDrive: function(d) {
      sel.drive = d;
      var lhd = g('mkvfit-lhd'), rhd = g('mkvfit-rhd');
      if (lhd) lhd.classList.toggle('active', d === 'LHD');
      if (rhd) rhd.classList.toggle('active', d === 'RHD');
      clearStepsFrom('engine'); onVehicleChange();
      if (!DB) return;
      var genY = window.MATRIKAR_GEN_YEAR ? window.MATRIKAR_GEN_YEAR(sel._genYears || [sel.year], sel.year) : sel.year;
      var fuels = uniq(DB.filter(function(r) {
        return r.make === sel.make && r.model === sel.model && r.year === genY && r.sub === sel.sub && String(r.seats) === sel.seats;
      }).map(function(r) { return r.fuel; }));
      if (!fuels.length) fuels = ['Petrol/Diesel'];
      // P8 AUTO-SELECT : if 1 fuel, skip step display + auto-call pFuel
      if (fuels.length === 1) {
        setTimeout(function() { window.MKVFIT.pFuel(fuels[0]); }, 250);
        return;
      }
      g('mkvfit-pills-engine').innerHTML = fuels.map(function(f) {
        return '<div class="mkvfit-pill" onclick="MKVFIT.pFuel(\'' + esc(f) + '\')">' + f + '</div>';
      }).join('');
      g('mkvfit-step-engine').style.display = 'flex';
    },

    pFuel: function(f) {
      sel.fuel = f;
      g('mkvfit-pills-engine').querySelectorAll('.mkvfit-pill').forEach(function(p) { p.classList.toggle('active', p.textContent === f); });
      g('mkvfit-confirm-wrap').style.display = 'block';
      onVehicleChange();
      // P8 AUTO-CONFIRM : if all fields filled, trigger press animation + confirm
      tryAutoConfirm();
    },

    confirm: function() {
      if (!sel.make || !sel.model || !sel.year || !sel.sub || !sel.seats || !sel.drive || !sel.fuel) {
        alert('Please complete all vehicle information before confirming'); return;
      }
      try { localStorage.setItem('matrikar_vehicle', JSON.stringify(sel)); } catch(e) {}
      updateCartProperties(sel);
      var displayName = sel.make + ' ' + sel.model + (sel.sub ? ' ' + sel.sub : '') + ' (' + sel.year + ')';
      var vehicleEl = g('mkvfit-vehicle-name'), detailsEl = g('mkvfit-vehicle-details');
      if (vehicleEl) vehicleEl.textContent = displayName;
      if (detailsEl) detailsEl.textContent = formatVehicleDetails(sel);
      g('mkvfit-selector').style.display = 'none';
      g('mkvfit-saved').style.display = 'flex';
      if (btnObserver) { btnObserver.disconnect(); btnObserver = null; }
      onVehicleChange();
      document.dispatchEvent(new CustomEvent('matrikar:vehicleSelected', { detail: sel }));
    },

    resetToEmpty: resetToEmpty
  };

  // ─── Initialisation ───────────────────────────────────────────────────────
  function init() {
    ensureCartProperties();
    loadSavedVehicle();

    var changeBtn  = g('mkvfit-change-btn');
    var confirmBtn = g('mkvfit-confirm-btn');
    if (changeBtn)  changeBtn.onclick  = function() { resetToEmpty(); };
    if (confirmBtn) confirmBtn.onclick = function() { window.MKVFIT.confirm(); };

    ['make','model','year'].forEach(function(k) {
      var btn = g('mkvfit-btn-' + k);
      if (btn) btn.onclick = function() { togDrop(k); };
      var src = g('mkvfit-search-' + k);
      if (src) src.oninput = function() { filterList(k); };
    });

    document.addEventListener('click', function(e) {
      var wrap = g('mkvfit-wrap');
      if (wrap && !wrap.contains(e.target)) closeDrops();
    });

    document.addEventListener('variant:changed', reapplyButtonState);
    document.addEventListener('change', function(e) {
      if (
        e.target.matches('[data-option-position]') ||
        e.target.matches('.variant-set-card input[type="radio"]') ||
        e.target.matches('[name="id"]')
      ) {
        reapplyButtonState();
      }
    });

    attachButtonObserver();
    waitForDB(function() { if (DB && DB.length > 0) initMakes(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
